
export const convertObjKey = (dataForm)=>{
    return {}
}

export const FomatDate = (date) =>{
  if (date) return date.format("DD/MM/YYYY");
  return "";
}

export const validateEmail = (email) => {
  return String(email)
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

export const plainText = (html)=>{
  if (html){
    return html.replace(/<style([\s\S]*?)<\/style>/gi, ' ')
    .replace(/<script([\s\S]*?)<\/script>/gi, ' ')
    .replace(/(<(?:.|\n)*?>)/gm, ' ')
    .replace(/\s+/gm, ' ')
    .replace("&nbsp;",' ')
    .replace("&nbsp;",' ')
  }
  return ""
}


export const formatPath = (path, ...params) => {
    if (!path) return path;
  
    let match = path.match(/:[a-z][a-z\d_]*\??/gi);
    if (!match) return path;
  
    match
      .map(param => param.replace(/\?$/, ''))
      .filter((value, index, self) => self.indexOf(value) === index)
      .map((param, index) => path = path.replace(
        new RegExp(param + '\\??', 'gi'),
        (params[index] ?? '').toString()
      ));
  
    return path;
}

export const trueTypeOf = (obj) => Object.prototype.toString.call(obj).slice(8, -1).toLowerCase()


export const getQueryString = (init) => {
  const params = new URLSearchParams();
  Object.keys(init).map((k) => {
    const type = trueTypeOf(init[k]);
    switch (type) {
      case 'object':
        // params 
        break;
      case 'string':
      case 'number':
        params.append(k,init[k].toString())
        break;
      case 'array':
        init[k].map((item)=>{
          params.append(k,item)
        })
        break;
      default:
        break;
    }
    return k;
  })
  return params.toString()
}

// Scroll 
export const scrollTo = (top= 0, left= 0, behavior= 'smooth')=>{
    window.scrollTo({top, left, behavior});
}

// local stroge
export const getLocalItem = (name)=>{
  const data = localStorage.getItem(name);
  try {
   const parsing = JSON.parse(data);
   return parsing;
  } catch (e) {
    return data;
  }
}


export const getUserLocal =(key) =>{
    let user = getLocalItem(key)
    if(user) return user
    return null
}

export const removeLocalItem = (name) => {
  localStorage.removeItem(name);
};

export const setLocalItem = (name, data) => {
  localStorage.setItem(name, JSON.stringify(data));
};

export function formatDateYMD(dateString) {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}/${month}/${day}`;
}

export function formatDateYMD_HMS(dateString) {
  const date = new Date(dateString);

  // Set the options for formatting date components
  const optionsDate = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    timeZone: 'Asia/Tokyo', // Japan timezone
  };

  // Set the options for formatting time components
  const optionsTime = {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZone: 'Asia/Tokyo', // Japan timezone
  };

  // Use toLocaleString with the options for date and time
  const formattedDate = date.toLocaleString('ja-JP', optionsDate);
  const formattedTime = date.toLocaleString('ja-JP', optionsTime);

  return `${formattedDate} ${formattedTime}`;
}

export function formatDateToSecond(dateString) {
  return dateString.substring(0, 19);
}
